<script >
import { ref, onMounted, onUnmounted } from 'vue-demi';
import TabHeader from './tab-header.vue';
import useTabCssPropertys from './useTabCssPropertys';
import { isElementInViewport } from '../utils';
import { POSITION } from '../constant';
/* 容器插件暂不支持组合式，在普通的script中声明 */
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
import ChildItem from '../children/tab-pane/render/index.vue';
import { CHILD } from '../constant';
const __sfc_main = {
  mixins: [ComplexComp.Inner.Parent.Mixins({
    [CHILD]: ChildItem
  })]
};
__sfc_main.props = {
  tpl: Object
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    throttle
  } = require('@futuweb/fego-bridge');
  const props = __props;

  // css变量
  const {
    cssPropertys
  } = useTabCssPropertys(props.tpl);

  // 当前激活的tab
  const current = ref(0);
  const childrenRefs = ref();
  const tabBodyRef = ref();
  const setActive = id => {
    current.value = id;
  };
  const scrollToActive = id => {
    const child = childrenRefs.value.find(c => c.$children[0].tpl.id === id);
    if (child?.$el) {
      const {
        offsetHeight,
        offsetTop
      } = child.$el;
      const mid = props.tpl?.props?.activePosition === POSITION.MID;
      const top = mid ? offsetTop + offsetHeight / 2 : offsetTop;
      tabBodyRef.value.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  let watchScroll;
  const initWatchScroll = () => {
    const children = childrenRefs.value;
    const root = tabBodyRef.value;
    const fn = () => {
      let active = null;
      children.forEach(child => {
        if (!active && isElementInViewport(child.$el, root)) {
          active = child;
        }
      });
      if (active && active !== current.value) {
        console.log('active', active?.$children[0].tpl.id);
        // 容器包了一层
        setActive(active?.$children[0].tpl.id);
      }
    };
    watchScroll = throttle(fn, 50);
    root.addEventListener('scroll', watchScroll);
  };
  const unWatchScroll = () => {
    watchScroll && tabBodyRef.value.removeEventListener('scroll', watchScroll);
  };
  onMounted(initWatchScroll);
  onUnmounted(unWatchScroll);
  return {
    cssPropertys,
    current,
    childrenRefs,
    tabBodyRef,
    scrollToActive
  };
};
__sfc_main.components = Object.assign({
  TabHeader
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <div class="vertical-anchor-tab" ref="verticalTabRef" :style="cssPropertys">
        <tab-header :tpl="tpl" :value="current" @setActive="scrollToActive"></tab-header>
        <div class="vertical-anchor-tab-body" ref="tabBodyRef">
            <inner-children-renderer
                ref="childrenRefs"
                v-for="c in tpl.children"
                :key="c.id"
                :children="c"
            />
        </div>
    </div>
</template>
<style lang="less" scoped>
@import '../common.less';
</style>
